import React from "react";

import AuthUserContext from "../Auth/AuthUserContext";
import { fire, auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";

const withAuth = Component => {
  class WithAuth extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        authUser: auth.currentUser
      };
    }

    componentDidMount() {
      auth.onAuthStateChanged(authUser => {
        if (authUser !== null) {
          authUser["isPaymentValid"] = false; //initialization
          authUser["isAdmin"] = false; // initialization
          authUser["isSuperAdmin"] = false; //initialization
          authUser["isTutorialCompleted"] = false; //initialization

          // const firebaseGroupAcc = fire.database().ref('groupAccounts');
          // const firebase

          customLog(authUser.metadata.lastSignInTime);

          const userSettings = fire
            .database()
            .ref("userSettings")
            .child(auth.currentUser.uid);

          userSettings
            .once("value")
            .then(snapshot => {
              if (snapshot.exists) {
                //?if the user has isTutorialCompleted variable
                if (snapshot.val().isTutorialCompleted !== null && snapshot.val().isTutorialCompleted !== undefined) {
                  var isTutorialCompleted = snapshot.val().isTutorialCompleted;
                  authUser["isTutorialCompleted"] = isTutorialCompleted;
                } else {
                  userSettings.child("isTutorialCompleted").set(false);
                }
              } //? if user have no data in userSetting (mean they never change langauge before)
              else {
                userSettings.child("language").set("en");

                userSettings.child("isTutorialCompleted").set(false);
              }
            })
            .then(() => {
              const lastLogon =
                new Date(authUser.metadata.lastSignInTime).getTime() / 1000;
              const currTimeStamp = new Date().getTime() / 1000;
              const twoDaysUnix = 86400 * 2;
              customLog(lastLogon);
              customLog(currTimeStamp);

              if (currTimeStamp - lastLogon >= twoDaysUnix) {
                customLog("Customer last logon was more than 2 days ! ");
                customLog("Signing customer out !");
                auth.signOut();
                this.setState(() => ({ authUser: null }));
              } else {
                customLog("User Logon within 2 days");
                fire
                  .database()
                  .ref("groupAccounts")
                  .once("value")
                  .then(snapshot => {
                    if (snapshot.exists()) {
                      snapshot.forEach(superAdmin => {
                        const superAdminData = superAdmin.val();
                        // customLog(superAdminData.members);
                        const memberDetails = superAdminData.members;
                        for (let eachMember in memberDetails) {
                          // customLog(memberDetails[eachMember]);
                          const eachMemberDetails = memberDetails[eachMember];
                          const eachMemberEmail = eachMemberDetails.memberEmail;
                          // const superAdminID = superAdmin.key;

                          //?Check if the user has completed tutorial

                          if (eachMemberEmail === authUser.email) {
                            if (superAdminData.payment.isPaymentValid) {
                              authUser["isPaymentValid"] = true;
                            }

                            if (eachMemberDetails.isSuperAdmin) {
                              // customLog(superAdminID);
                              authUser["isSuperAdmin"] = true;
                            }

                            if (eachMemberDetails.isAdmin) {
                              authUser["isAdmin"] = true;
                            }
                          } else {
                            authUser["notPartOfMember"] = true;
                          }
                        }
                      });
                    }
                  })
                  .then(setState => {
                    this.setState(() => ({ authUser: authUser }));
                  });
              }
            });
        } else {
          this.setState(() => ({ authUser: null }));
        }
      });
    }

    render() {
      const { authUser } = this.state;
      return (
        <AuthUserContext.Provider value={authUser}>
          <Component />
        </AuthUserContext.Provider>
      );
    }
  }

  return WithAuth;
};

export default withAuth;
